import React from 'react';
import PermissionContext from './PermissionContext';
import OrganizationAPI from 'src/admin/Organization/API/OrganizationAPI';
import { LoadingPage } from 'src/components/common';

const PermissionStore = (props: any) => {
	const [permissions, setPermissions] = React.useState([] as PermissionDTO[]);
	const [isInitializing, setIsInitializing] = React.useState(true);

	React.useEffect(() => {
		OrganizationAPI.getPermissions()
			.then(response => setPermissions(response))
			.then(() => setIsInitializing(false));
	}, []);

	const initialState = {
		permissions,
		isInitializing
	};

	return (
		<PermissionContext.Provider value={initialState}>
			{initialState.isInitializing ? (<LoadingPage />) : props.children}
		</PermissionContext.Provider>);
};

export default PermissionStore;